(function() {
  'use strict';

  /* =============================================
     Config — read from section data attributes
     ============================================= */
  var KLAVIYO_KEY = '';
  var EMAIL_LIST_ID = '';
  var SMS_LIST_ID = '';

  function getConfig() {
    var el = document.querySelector('[data-klaviyo-public-key]');
    if (el) {
      KLAVIYO_KEY = el.getAttribute('data-klaviyo-public-key') || '';
      EMAIL_LIST_ID = el.getAttribute('data-klaviyo-email-list') || '';
      SMS_LIST_ID = el.getAttribute('data-klaviyo-sms-list') || '';
    }
  }

  /* =============================================
     Add to Cart
     ============================================= */

  function handleAddToCart(button) {
    if (button.classList.contains('is-loading')) return;

    var variantId = button.getAttribute('data-variant-id');
    var btnText = button.querySelector('.variant-card__btn-text');

    if (btnText) btnText.textContent = 'Adding...';
    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: 1
      })
    })
    .then(function(response) {
      if (!response.ok) throw new Error('Failed to add to cart');
      return response.json();
    })
    .then(function() {
      button.classList.remove('is-loading');
      button.classList.add('is-added');
      if (btnText) btnText.textContent = 'Added!';

      refreshCartBubble();

      setTimeout(function() {
        button.classList.remove('is-added');
        if (btnText) btnText.textContent = 'Add to cart';
        button.disabled = false;
      }, 2000);
    })
    .catch(function(error) {
      console.error('Add to cart error:', error);
      button.classList.remove('is-loading');
      if (btnText) btnText.textContent = 'Error - Retry';
      button.disabled = false;

      setTimeout(function() {
        if (btnText) btnText.textContent = 'Add to cart';
      }, 3000);
    });
  }

  function refreshCartBubble() {
    fetch('/cart.js', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(function(response) { return response.json(); })
    .then(function(cart) {
      document.querySelectorAll('.cart-count-bubble').forEach(function(bubble) {
        var countSpan = bubble.querySelector('span[aria-hidden="true"]');
        if (countSpan) countSpan.textContent = cart.item_count;
        bubble.classList.toggle('hidden', cart.item_count === 0);
      });

      var sectionIds = [];
      var cartDrawer = document.querySelector('cart-drawer');
      var cartNotification = document.querySelector('cart-notification');

      if (cartDrawer) sectionIds.push('cart-drawer');
      if (cartNotification) sectionIds.push('cart-notification-product');

      if (sectionIds.length > 0) {
        fetch('/?sections=' + sectionIds.join(','))
        .then(function(r) { return r.json(); })
        .then(function(sections) {
          Object.keys(sections).forEach(function(id) {
            var target = document.getElementById(id) ||
                         document.querySelector('[id^="' + id + '"]');
            if (target && sections[id]) {
              var parser = new DOMParser();
              var doc = parser.parseFromString(sections[id], 'text/html');
              var newContent = doc.getElementById(id) ||
                               doc.querySelector('[id^="' + id + '"]');
              if (newContent) target.innerHTML = newContent.innerHTML;
            }
          });
        })
        .catch(function() {});
      }
    })
    .catch(function(error) {
      console.error('Error refreshing cart:', error);
    });
  }

  /* =============================================
     Notify Me Modal — Klaviyo BIS via API
     ============================================= */

  var modal = null;
  var currentVariantId = null;
  var REVISION = '2025-07-15';

  function openBISModal(button) {
    getConfig();
    modal = document.getElementById('bis-modal');
    if (!modal) return;

    currentVariantId = button.getAttribute('data-variant-id');

    // Reset to email step
    showStep('email');
    clearMessages();

    // Reset inputs
    var emailInput = modal.querySelector('#bis-email');
    var phoneInput = modal.querySelector('#bis-phone');
    var marketingCheckbox = modal.querySelector('#bis-marketing');
    var submitBtns = modal.querySelectorAll('.bis-modal__submit');

    if (emailInput) emailInput.value = '';
    if (phoneInput) phoneInput.value = '';
    if (marketingCheckbox) marketingCheckbox.checked = false;
    submitBtns.forEach(function(btn) {
      btn.disabled = false;
      btn.textContent = 'Notify Me';
    });

    // Open
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    if (emailInput) {
      setTimeout(function() { emailInput.focus(); }, 150);
    }
  }

  function closeBISModal() {
    if (!modal) modal = document.getElementById('bis-modal');
    if (modal) {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      currentVariantId = null;
    }
  }

  function showStep(step) {
    if (!modal) return;
    modal.querySelectorAll('.bis-modal__step').forEach(function(el) {
      el.classList.remove('is-active');
    });
    var target = modal.querySelector('[data-step="' + step + '"]');
    if (target) target.classList.add('is-active');
  }

  function clearMessages() {
    if (!modal) return;
    modal.querySelectorAll('.bis-modal__message').forEach(function(el) {
      el.className = 'bis-modal__message';
      el.style.display = 'none';
      el.textContent = '';
    });
  }

  function showMessage(type, text) {
    if (!modal) return;
    var activeStep = modal.querySelector('.bis-modal__step.is-active');
    if (!activeStep) return;
    var msgEl = activeStep.querySelector('.bis-modal__message');
    if (msgEl) {
      msgEl.textContent = text;
      msgEl.className = 'bis-modal__message ' + (type === 'success' ? 'is-success' : 'is-error');
      msgEl.style.display = 'block';
    }
  }

  /* --- API calls --- */

  function klaviyoFetch(endpoint, payload) {
    return fetch(
      'https://a.klaviyo.com/client/' + endpoint + '/?company_id=' + encodeURIComponent(KLAVIYO_KEY),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': REVISION
        },
        body: JSON.stringify(payload)
      }
    ).then(function(response) {
      if (!response.ok && response.status !== 202) {
        throw new Error('Klaviyo API error: ' + response.status);
      }
      return response;
    });
  }

  function subscribeBISEmail(email) {
    return klaviyoFetch('back-in-stock-subscriptions', {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          }
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + currentVariantId
            }
          }
        }
      }
    });
  }

  function subscribeMarketing(email) {
    if (!EMAIL_LIST_ID) return Promise.resolve();
    return klaviyoFetch('subscriptions', {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                subscriptions: {
                  email: {
                    marketing: { consent: 'SUBSCRIBED' }
                  }
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: { type: 'list', id: EMAIL_LIST_ID }
          }
        }
      }
    });
  }

  function subscribeSMSConsent(phone) {
    if (!SMS_LIST_ID) return Promise.resolve();
    return klaviyoFetch('subscriptions', {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                phone_number: phone,
                subscriptions: {
                  sms: {
                    marketing: { consent: 'SUBSCRIBED' }
                  }
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: { type: 'list', id: SMS_LIST_ID }
          }
        }
      }
    });
  }

  function subscribeBISSMS(phone) {
    return klaviyoFetch('back-in-stock-subscriptions', {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['SMS'],
          profile: {
            data: {
              type: 'profile',
              attributes: { phone_number: phone }
            }
          }
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + currentVariantId
            }
          }
        }
      }
    });
  }

  /* --- Form handlers --- */

  function handleEmailSubmit(e) {
    e.preventDefault();
    if (!KLAVIYO_KEY || !currentVariantId) return;

    var emailInput = modal.querySelector('#bis-email');
    var marketingCheckbox = modal.querySelector('#bis-marketing');
    var submitBtn = e.target.querySelector('.bis-modal__submit');
    var email = emailInput ? emailInput.value.trim() : '';

    if (!email) return;

    clearMessages();
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting...';
    }

    // 1. BIS email subscription
    var promises = [subscribeBISEmail(email)];

    // 2. Marketing opt-in if checked
    if (marketingCheckbox && marketingCheckbox.checked) {
      promises.push(subscribeMarketing(email));
    }

    Promise.all(promises)
    .then(function() {
      showMessage('success', "You're on the list! We'll email you when this item is back in stock.");
      if (e.target) e.target.style.display = 'none';
    })
    .catch(function(err) {
      console.error('BIS email error:', err);
      showMessage('error', 'Something went wrong. Please try again.');
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Notify Me';
      }
    });
  }

  function handleSMSSubmit(e) {
    e.preventDefault();
    if (!KLAVIYO_KEY || !currentVariantId) return;

    var countryCode = modal.querySelector('#bis-country-code');
    var phoneInput = modal.querySelector('#bis-phone');
    var submitBtn = e.target.querySelector('.bis-modal__submit');

    var code = countryCode ? countryCode.value : '+1';
    var number = phoneInput ? phoneInput.value.trim().replace(/[^0-9]/g, '') : '';

    if (!number) return;

    var fullPhone = code + number;

    clearMessages();
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting...';
    }

    // 1. SMS consent first (required), then 2. BIS SMS subscription
    subscribeSMSConsent(fullPhone)
    .then(function() {
      return subscribeBISSMS(fullPhone);
    })
    .then(function() {
      showMessage('success', "You're on the list! We'll text you when this item is back in stock.");
      if (e.target) e.target.style.display = 'none';
    })
    .catch(function(err) {
      console.error('BIS SMS error:', err);
      showMessage('error', 'Something went wrong. Please try again.');
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Notify Me';
      }
    });
  }

  /* =============================================
     Event Delegation
     ============================================= */

  document.addEventListener('click', function(e) {
    // Add to Cart
    var atcBtn = e.target.closest('.variant-card__add-to-cart');
    if (atcBtn) {
      e.preventDefault();
      handleAddToCart(atcBtn);
      return;
    }

    // Notify Me — open BIS modal
    var notifyBtn = e.target.closest('.variant-card__notify-me');
    if (notifyBtn) {
      e.preventDefault();
      openBISModal(notifyBtn);
      return;
    }

    // Close modal
    if (e.target.closest('.bis-modal__close') || e.target.classList.contains('bis-modal__overlay')) {
      closeBISModal();
      return;
    }

    // Toggle to SMS step
    if (e.target.closest('[data-bis-toggle="sms"]')) {
      e.preventDefault();
      clearMessages();
      showStep('sms');
      var phoneInput = modal.querySelector('#bis-phone');
      if (phoneInput) setTimeout(function() { phoneInput.focus(); }, 100);
      return;
    }

    // Toggle to Email step
    if (e.target.closest('[data-bis-toggle="email"]')) {
      e.preventDefault();
      clearMessages();
      showStep('email');
      var emailInput = modal.querySelector('#bis-email');
      if (emailInput) setTimeout(function() { emailInput.focus(); }, 100);
      return;
    }
  });

  // Form submissions
  document.addEventListener('submit', function(e) {
    if (e.target.closest('#bis-email-form')) {
      handleEmailSubmit(e);
    }
    if (e.target.closest('#bis-sms-form')) {
      handleSMSSubmit(e);
    }
  });

  // ESC to close
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeBISModal();
  });

})();
